import React from 'react'
import TableLayout from '../../components/TableLayout'
import Search from '../../components/Search'
import { Col, Row, Form } from 'antd'

const current = JSON.parse(localStorage.getItem('sucursal'))

const ReportCashdrawalContainer = props => {
    const [subsidiary, setSubsidiary] = React.useState({
        id: current ? current.id : '',
        name: current ? current.name : '',
    })

    const columns = [
        {
            title: 'Sucursal',
            dataIndex: 'subsidiary.name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Usuario en caja',
            dataIndex: 'user.full_name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Turno',
            dataIndex: 'shift_unique_id',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Fecha y Hora',
            dataIndex: 'withdrawal_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Razón',
            dataIndex: 'cash_withdrawal_reason.name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Cantidad retirada',
            dataIndex: 'amount',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Receptor',
            dataIndex: 'receptor',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
        },
    ]

    return (
        <>
            <TableLayout
                title="Reporte de retiro de efectivo"
                columns={columns}
                resource={`cash-withdrawals`}
                params={`&filter[subsidiary_id]=${subsidiary.id}`}
                actions={['show']}
                additionalFilter={
                    <Row gutter={24}>
                        <Col lg={6} md={24} sm={24}>
                            <Form.Item label="Sucursal">
                                <Search
                                    value={subsidiary.name}
                                    placeholder="Sucursal"
                                    onSearch={value => `/api/subsidiaries?filter[active]&filter[name]=${value}`}
                                    onChange={(key, value) => {
                                        setSubsidiary(value)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                }
            />
        </>
    )
}

export default ReportCashdrawalContainer
